import React, { useState, useEffect } from "react";
import { BACKEND_URL } from "../../../consts";
import SearchResult from "./SearchResult";

const SearchSearch = () => {
    const [searchTerm, setSearchTerm] = useState("");
    const [placeholder, setPlaceholder] = useState("Введите ключевые слова или код товара");
    const [results, setResults] = useState([]);
    const [loading, setLoading] = useState(false);
    const [foundCount, setFoundCount] = useState(0); 
    const [hasSearched, setHasSearched] = useState(false); 

    const handleInputChange = (event) => {
        setSearchTerm(event.target.value);
    };

    const handleSearch = async () => {
        if (searchTerm.length < 3) {
            setFoundCount(0);
            setResults([]);
            setHasSearched(true); 
            return; 
        }

        setLoading(true);
        setFoundCount(0); 
        setHasSearched(true); 
        try {
            const response = await fetch(`${BACKEND_URL}/api/v1/tnved/search?query=${searchTerm}`);
            const data = await response.json();
            setResults(data);
            setFoundCount(data.length); 
        } catch (error) {
            console.error("Ошибка при выполнении поиска:", error);
        } finally {
            setLoading(false);
        }
    };

    const handleKeyDown = (event) => {
        if (event.key === "Enter") {
            handleSearch(); 
        }
    };

    const updatePlaceholder = () => {
        if (window.innerWidth < 640) {
            setPlaceholder("Введите ключевые слова/код ");
        }
    };

    useEffect(() => {
        updatePlaceholder();
        window.addEventListener('resize', updatePlaceholder);

        return () => {
            window.removeEventListener('resize', updatePlaceholder);
        };
    }, []);

    return (
        <div className="">
            <div>
                <div className="max-w-[785px] p-[15px] flex items-center justify-between border-solid border-[1px] border-[#C9CED2] rounded-[16px]">
                    <div>
                        <div className="text-[#626C75] text-[14px]">Поиск</div>
                        <input
                            type="text"
                            className="outline-none sm:w-[500px] w-[230px]"
                            placeholder={placeholder}
                            value={searchTerm}
                            onChange={handleInputChange}
                            onKeyDown={handleKeyDown}
                        />
                    </div>
                    <div>
                        <button onClick={handleSearch} className="bg-[#C3372E] p-[13px] rounded-[140px]">
                            <img src="/img/search/Zalupa.svg" alt="Поиск" />
                        </button>
                    </div>
                </div>
                <div className="mt-[12px] text-[16px]">
                    {loading ? 
                        <div className="text-[#626C75]">
                            Загрузка...
                        </div>
                     : hasSearched && foundCount > 0 ? 
                        <div className="text-[#C3372E]">
                            Найдено {foundCount} подходящих вариантов
                        </div>
                     : hasSearched && foundCount === 0 ? 
                        <div className="text-[#C3372E]">
                            Ничего не найдено
                        </div>
                     : 
                        <div className={`text-[#626C75] `}>
                            Для начала поиска Вам необходимо ввести минимум 3 символа
                        </div>
                    }
                </div>
            </div>

            {results.length > 0 && <SearchResult results={results} />}
        </div>
    );
};

export default SearchSearch;
